module.exports = __webpack_public_path__ + "img/lava.5975d23e.jpg";